<template>
  <v-container fluid class="white pb-10 pt-7 px-5">
    <div class="outlined-card pa-4 mb-6">
      <icon-title text="REBATE" />
    </div>
    <table-toolbar
      class="mt-3"
      hide-delete
      :search="search"
      :message="`Trimestre: ${quarterPeriodLabel}`"
      :selected-items="selectedItems"
      :downloading="downloading"
      @update:search="(e) => (search = e)"
      @refresh="getLoadRebateDetail(quarter)"
      @export="exportSelected"
    />
    <rebate-detail-table
      :data="rebateDetail"
      :search="search"
      :items-per-page="itemsPerPage"
      :hide-headers="[]"
      @itemSelected="onItemSelected"
    />
  </v-container>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import IconTitle from '@/components/IconTitle.vue';
  import RebateDetailTable from '@/components/tables/RebateDetailTable.vue';
  import TableToolbar from '@/components/tables/TableToolbar.vue';
  import Quarter from '@/core/models/quarter';
  import saveFile from '@/mixins/saveFile';

  export default {
    name: 'BonoRebateDetail',
    components: { TableToolbar, RebateDetailTable, IconTitle },
    mixins: [saveFile],
    data() {
      return {
        search: '',
        selectedItems: [],
        downloading: false,
      };
    },
    computed: {
      ...mapGetters('bonusCustomer', ['rebateDetail', 'rebateDetailError']),
      ...mapGetters('selectedUser', [
        'loadCustomerError',
        'noCustomerSelected',
        'customer',
      ]),
      quarter() {
        return this.$route.params.quarter;
      },
      quarterPeriodLabel() {
        const quarterParsed = Quarter.parse(this.quarter);
        return Quarter.getPeriodLabel(quarterParsed.quarter);
      },
      itemsPerPage() {
        return this.rebateDetail.length;
      },
    },
    async mounted() {
      await this.loadCustomer();

      this.getLoadRebateDetail(this.quarter);
    },
    methods: {
      ...mapActions('bonusCustomer', ['setRebateDetail', 'getExcelFile']),
      ...mapActions('selectedUser', ['loadCustomer']),

      async getLoadRebateDetail(selected) {
        const quarterParsed = Quarter.parse(selected);

        await this.setRebateDetail({
          customer: this.customer.customer,
          quarter: quarterParsed.quarter,
          year: quarterParsed.year,
        });

        if (this.rebateDetailError) {
          this.$toast.error(this.rebateDetailError);
        }
      },
      onItemSelected(items) {
        this.selectedItems = items;
      },
      async exportSelected() {
        this.downloading = true;
        const response = await this.getExcelFile({
          customer: this.customer.customer,
          selectedItems: this.selectedItems,
        });

        if (response.ok) {
          this.saveFileToDevice(response.file.data, 'detalle_rebate', 'xlsx');
        } else {
          this.$toast.error(response.message);
        }

        this.downloading = false;
      },
    },
  };
</script>
